export default "__VITE_ASSET__CrSGzCB2__"